// Нехватка средств на лицевом счёте при подписании платного заказа.
// Формат ошибки бэк не описывает, поэтому распознаём по нескольким признакам,
// а сумму к пополнению показываем, только если бэк её вернул.
const NO_FUNDS_RE = /недостат|не хватает|средств|баланс|қаражат|insufficient|no[\s_-]?funds|balance/i;
const AMOUNT_KEYS = [
  "requiredAmount",
  "missingAmount",
  "amountToTopUp",
  "topUpAmount",
  "shortage",
  "deficit",
  "needAmount",
];

const formatAmount = (value: number) =>
  new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

export const getNoFundsMessage = (
  error: any,
  t: (key: string, options?: Record<string, unknown>) => string,
): string | null => {
  const response = error?.response;
  const data = response?.data ?? {};
  const payload = data?.data && typeof data.data === "object" ? data.data : data;
  const text = [data?.message, data?.code, data?.errorCode, payload?.status, data?.status]
    .filter(Boolean)
    .join(" ");

  const isNoFunds =
    response?.status === 402 ||
    payload?.status === "PROCESSED_NO_FUNDS" ||
    NO_FUNDS_RE.test(text);
  if (!isNoFunds) return null;

  const amountKey = AMOUNT_KEYS.find(
    (key) => typeof payload?.[key] === "number" && payload[key] > 0,
  );
  return amountKey
    ? t("new_order.no_funds_with_amount", { amount: formatAmount(payload[amountKey]) })
    : t("new_order.no_funds");
};
